export default __webpack_public_path__ + "static/media/mobile-footer.65d5ecce.svg";